import { useCallback, useMemo, useState } from "react";

import { LoadingSpinner } from "twyne-new.ui";

import InfiniteScroll from "@/components/Grid/components/Table/InfiniteScroll";

import { useChangeHistory } from "../../store";

export default function Pagination({ onNextPage }) {
  const { collections: { hasNextPage }, loading } = useChangeHistory()
  const shouldLoad = hasNextPage && !loading

  return <div className="flex w-full justify-center items-center h-14">
    {shouldLoad ? <InfiniteScroll onVisit={onNextPage} hasMore={shouldLoad} /> : null}
    {loading ? <LoadingSpinner /> : null}
  </div>
}

export function usePagination() {
  const [sizePerPage, setSizePerPage] = useState(25)

  const onNextPage = useCallback(() => {
    setSizePerPage(sizePerPage => sizePerPage * 2)
  }, [])

  const reset = useCallback(() => {
    setSizePerPage(25)
  }, [])

  return useMemo(() => ({
    onNextPage,
    reset,
    options: {
      page: 1,
      sizePerPage,
    },
  }), [sizePerPage, onNextPage, reset])
}
